import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { NAV_ITEMS, IMG } from '../mock/mock';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-40 transition-all duration-300 ${scrolled ? 'bg-black/30 backdrop-blur-md border-b border-white/15 shadow-[0_1px_0_0_rgba(43,168,192,0.15)]' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2.5">
          <img src={IMG.logo} alt="Eco-Lak" className="w-9 h-9 object-contain" />
          <span className="text-white text-xl font-medium tracking-tight">Eco-Lak Kft.</span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((it) => (
            <a
              key={it.label}
              href={it.href}
              className="text-white/80 hover:text-[#2BA8C0] text-[14px] tracking-wide transition-colors"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#kapcsolat"
            className="px-5 py-2.5 rounded-md border border-white/30 text-white text-[14px] hover:bg-white/10 transition-colors"
          >
            Ingyenes konzultáció
          </a>
        </div>

        <button
          aria-label="menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a1d2e]/95 backdrop-blur-md border-t border-white/15 shadow-[0_8px_24px_rgba(0,0,0,0.35)]">
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV_ITEMS.map((it) => (
              <a key={it.label} href={it.href} onClick={() => setOpen(false)} className="text-white/85 text-[15px]">
                {it.label}
              </a>
            ))}
            <a href="#kapcsolat" onClick={() => setOpen(false)} className="mt-2 text-center px-5 py-3 rounded-md border border-white/30 text-white">
              Ingyenes konzultáció
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
